<script setup lang="ts">
import * as commonConstants from '@/constants/common';

export interface Props {
  term?: string;
  details?: string | number;
}
const props = withDefaults(defineProps<Props>(), {
  term: commonConstants.EM_DASH,
  details: commonConstants.EM_DASH,
});
</script>

<template>
  <div
    :class="$style.smsChatDetailsDescListItem"
    data-testid="smsChatDetailsDescListItem"
  >
    <dt :class="$style.dt">
      {{ props.term }}
    </dt>
    <dd :class="$style.dd">
      {{ props.details }}
    </dd>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatDetailsDescListItem {
}
  .dt {
    color: colors.$color-text-tertiary;
    font-size: 12px;
    font-weight: 500;
  }
  .dd {
    color: colors.$color-text-primary;
    font-size: 16px;
    margin: 0;
  }
</style>
